// extracted by mini-css-extract-plugin
export default {"prescription":"tasks-generator_prescription__pRogX","prescriptionSecond":"tasks-generator_prescriptionSecond__VdmsH"};